interface ShareUser {
  isSeller?: boolean | null;
  shareHideListings?: boolean | null;
  shareUtmSource?: string | null;
  username?: string | null;
}

function shareSource(user: ShareUser | undefined): string | undefined {
  const configuredSource = user?.shareUtmSource?.trim();
  if (configuredSource) return configuredSource;
  const username = user?.username?.trim();
  if (username) return username;
  return undefined;
}

function shareMedium(user: ShareUser | undefined): string {
  if (!user?.isSeller) return "share";
  return user.shareHideListings ? "partner" : "referral";
}

export function buildCurrentShareUrl(user: ShareUser | undefined): string {
  const url = new URL(window.location.href);
  const source = shareSource(user);
  if (source) url.searchParams.set("utm_source", source);
  url.searchParams.set("utm_medium", shareMedium(user));
  url.searchParams.set("utm_campaign", "share");
  return url.toString();
}
